import { cn as e } from "../../lib/utils.es.js";
import { Skeleton as t } from "../ui/skeleton.es.js";
import { TableBody as n, TableCell as r, TableHead as i, TableHeader as a, TableRow as o } from "../ui/table.es.js";
import { useEffect as s, useRef as c, useState as l } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { flexRender as f, getCoreRowModel as ee, getExpandedRowModel as te, getFilteredRowModel as ne, getSortedRowModel as re, useReactTable as p } from "@tanstack/react-table";
import { useVirtualizer as m } from "@tanstack/react-virtual";
// libs/ui-lib/src/components/DataTable/DataTable.tsx
var h = 300, g = [
	"sk-1",
	"sk-2",
	"sk-3",
	"sk-4",
	"sk-5",
	"sk-6"
], _ = "a,button,input,select,textarea,label,[role=\"button\"],[role=\"link\"],[role=\"menuitem\"],[role=\"checkbox\"],[contenteditable=\"true\"],[data-row-click-ignore]";
function v(e) {
	return e instanceof Element && e.closest(_) !== null;
}
function y(e, t, n) {
	s(() => {
		if (!n) return;
		if (t == null) {
			n(void 0);
			return;
		}
		let r = e.findIndex((e) => e.id === t);
		n(r >= 0 ? r : void 0);
	}, [
		e,
		t,
		n
	]);
}
function b({ columns: _, data: b, getRowId: ie, onLoadMore: x, hasMore: S = !1, isFetchingMore: C = !1, isLoading: w = !1, emptyState: ae, toolbar: T, estimatedRowHeight: E = 44, className: D, scrollClassName: O, tableClassName: k, rowSelection: A, onRowSelectionChange: j, getSubRows: M, getRowCanExpand: N, expanded: P, onExpandedChange: F, expandOnRowClick: I, onRowClick: L, defaultSorting: R, selectedRowId: z, onSelectedRowIndexChange: B, highlightBorderOnSelection: oe = !0 }) {
	let [V, H] = l(R ?? []), [U, W] = l({}), G = P ?? U, K = c(null), q = p({
		data: b,
		columns: _,
		state: {
			sorting: V,
			expanded: G,
			...A !== void 0 && { rowSelection: A }
		},
		onSortingChange: H,
		onRowSelectionChange: j,
		onExpandedChange: F ?? W,
		getSubRows: M,
		getRowCanExpand: N,
		getRowId: ie,
		getCoreRowModel: ee(),
		getSortedRowModel: re(),
		getFilteredRowModel: ne(),
		getExpandedRowModel: te()
	}), J = q.getRowModel().rows;
	y(J, z, B);
	let Y = m({
		count: J.length,
		getScrollElement: () => K.current,
		estimateSize: () => E,
		overscan: 8
	}), X = Y.getVirtualItems(), se = Y.getTotalSize(), Z = X.length > 0 ? X[0]?.start ?? 0 : 0, Q = X.length > 0 ? se - (X[X.length - 1]?.end ?? 0) : 0;
	s(() => {
		let e = K.current;
		if (!e || !x || !S) return;
		let t = () => {
			C || e.scrollHeight - e.scrollTop - e.clientHeight <= h && x();
		};
		return e.addEventListener("scroll", t, { passive: !0 }), t(), () => e.removeEventListener("scroll", t);
	}, [
		x,
		S,
		C,
		J.length
	]);
	let $ = q.getAllLeafColumns().length, ce = !w && J.length === 0, le = w && J.length === 0, ue = q.getHeaderGroups();
	return /* @__PURE__ */ d("div", {
		className: e("flex h-full min-h-0 w-full flex-col", D),
		children: [T ? /* @__PURE__ */ u("div", {
			className: "flex-none",
			children: T
		}) : null, /* @__PURE__ */ u("div", {
			ref: K,
			className: e("relative max-h-full min-h-0 overflow-auto rounded-md border border-border bg-background", O),
			"data-slot": "data-table-scroll",
			children: /* @__PURE__ */ d("table", {
				className: e("min-w-full caption-bottom border-collapse text-sm", k),
				children: [/* @__PURE__ */ u(a, {
					className: "sticky top-0 z-10 bg-muted",
					children: ue.map((e) => /* @__PURE__ */ u(o, {
						className: "border-border hover:bg-transparent",
						children: e.headers.map((e) => {
							let t = e.getSize(), n = e.column.columnDef.minSize, r = e.column.getCanSort(), a = r ? e.column.getIsSorted() : !1, o = r ? a === "asc" ? "ascending" : a === "desc" ? "descending" : "none" : void 0;
							return /* @__PURE__ */ u(i, {
								colSpan: e.colSpan,
								"aria-sort": o,
								style: {
									width: t === 150 ? void 0 : t,
									minWidth: n && n > 20 ? n : void 0
								},
								className: "h-auto p-0",
								children: e.isPlaceholder ? null : f(e.column.columnDef.header, e.getContext())
							}, e.id);
						})
					}, e.id))
				}), /* @__PURE__ */ d(n, { children: [
					Z > 0 && /* @__PURE__ */ u("tr", { children: /* @__PURE__ */ u("td", {
						colSpan: $,
						style: { height: Z }
					}) }),
					le ? g.map((e) => /* @__PURE__ */ u(o, {
						className: "border-border",
						children: q.getAllLeafColumns().map((e) => /* @__PURE__ */ u(r, {
							className: "p-3 align-middle",
							children: /* @__PURE__ */ u(t, { className: "h-4 w-full rounded" })
						}, e.id))
					}, e)) : null,
					ce ? /* @__PURE__ */ u("tr", { children: /* @__PURE__ */ u("td", {
						colSpan: $,
						className: "p-0",
						children: /* @__PURE__ */ u("div", {
							className: "flex h-full items-center justify-center py-10",
							children: ae ?? /* @__PURE__ */ u("span", {
								className: "text-muted-foreground text-sm",
								children: "No results."
							})
						})
					}) }) : X.map((t) => {
						let n = J[t.index];
						if (!n) return null;
						let i = I === !0 && n.getCanExpand(), a = n.id === z || n.getIsExpanded();
						return /* @__PURE__ */ u(o, {
							"data-index": t.index,
							"data-state": n.getIsSelected() ? "selected" : void 0,
							"data-active": a ? "true" : void 0,
							onClick: (e) => {
								v(e.target) || (i ? n.toggleExpanded() : L?.(n.original));
							},
							className: e("group/row border-border", (i || L) && "cursor-pointer", oe ? [
								"data-[active=true]:[&>td]:shadow-[inset_0_1px_0_0_var(--steel-blue),inset_0_-1px_0_0_var(--steel-blue)]",
								"data-[active=true]:[&>td:first-child]:shadow-[inset_3px_0_0_0_var(--steel-blue),inset_0_1px_0_0_var(--steel-blue),inset_0_-1px_0_0_var(--steel-blue)]",
								"last:data-[active=true]:[&>td:first-child]:rounded-bl-[7px]",
								"last:data-[active=true]:[&>td:last-child]:rounded-br-[7px]"
							] : "data-[active=true]:bg-muted"),
							style: { height: t.size },
							children: n.getVisibleCells().map((e) => /* @__PURE__ */ u(r, {
								className: "p-0 align-middle",
								children: f(e.column.columnDef.cell, e.getContext())
							}, e.id))
						}, n.id);
					}),
					Q > 0 && /* @__PURE__ */ u("tr", { children: /* @__PURE__ */ u("td", {
						colSpan: $,
						style: { height: Q }
					}) }),
					C && /* @__PURE__ */ u("tr", { children: /* @__PURE__ */ u("td", {
						colSpan: $,
						className: "p-2",
						children: /* @__PURE__ */ d("div", {
							className: "flex items-center gap-3 px-2 py-1.5",
							children: [/* @__PURE__ */ u(t, { className: "size-4 rounded-full" }), /* @__PURE__ */ u(t, { className: "h-3 flex-1" })]
						})
					}) })
				] })]
			})
		})]
	});
}
export { b as DataTable };
